import css from './backPane.module.scss';

import { useState } from 'react';

import { wait } from 'core/helpers/browser';
import { useStableCallback } from 'core/hooks/useStableCallback';

import { TWordCardSide } from '../shared';

const { ANIMATION_DURATION } = css;
const flipDuration = parseFloat(ANIMATION_DURATION) * 1000;

export enum AmimationStep {
  NONE = 0,
  TO_USER = 1,
  FROM_USER = 2,
}

function useFlipAnimation(duration: number) {
  const [animationStep, setAnimationStep] = useState(AmimationStep.NONE);

  const animate = useStableCallback(async () => {
    setAnimationStep(AmimationStep.TO_USER);
    await wait(duration / 2);
    setAnimationStep(AmimationStep.FROM_USER);
    await wait(duration / 2);
    setAnimationStep(AmimationStep.NONE);
  });

  return [animationStep, animate] as const;
}

export default function useFlipWordCardAnimation(
  side: TWordCardSide,
  setSide: (side: TWordCardSide) => void,
  setIsAnimating: (val: boolean) => void
): readonly [
  AmimationStep,
  (event: Event | React.SyntheticEvent | undefined) => Promise<void>,
] {
  const [step, animate] = useFlipAnimation(flipDuration);

  const flip = useStableCallback(
    async (event: Event | React.SyntheticEvent | undefined) => {
      try {
        if (event) event.preventDefault();
        if (step !== AmimationStep.NONE) return;

        setIsAnimating(true);
        await animate(); // wait for the animation's end
        setSide(TWordCardSide.back);
      } finally {
        setIsAnimating(false);
      }
    }
  );

  return [step, flip] as const;
}
